import {
  compose, withHandlers, withProps,
} from 'recompose';
import { prop } from 'ramda';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import Members from './members';
import { uiActions, uiSelectors } from '../../../../state/ui';
import { projectActions, projectSelectors } from '../../../../state/project';
import { projectsSelectors } from '../../../../state/projects';

const { getTabStatus } = uiSelectors;

const mapStateToProps = (state, { projectId }) => ({
  isProjectMembersTabOpen: getTabStatus(state)('isProjectMembersTabOpen'),
  membersList: projectSelectors.getProjectMembersList(state),
  project: projectsSelectors.getProject(state)(projectId),

  isPendingDelete: projectSelectors.getDeleteProjectMemberPending(state),
  isPendingInvite: projectSelectors.addMembersToProjectPending(state),
});

const mapDispatchToProps = ({
  openModal: uiActions.openModal,
  deleteMemberRequest: projectActions.deleteProjectMemberRequest,
  inviteMembersRequest: projectActions.addProjectMembersRequest,
});

const onDeleteMemberHandler = ({ deleteMemberRequest, projectId }) => (memberId, callbacks) => {
  deleteMemberRequest({ memberId, projectId }, {
    memberId,
    callbacks,
  });
};

const onInviteMemberHandler = ({ inviteMembersRequest, projectId }) => (memberIds, callbacks) => {
  inviteMembersRequest({ memberIds, projectId }, {
    callbacks,
  });
};
const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(['common']),
  withProps(({ membersList }) => ({
    membersList: membersList.map(member => (prop('id', member) ? prop('id', member) : member)),
  })),
  withHandlers({
    onDeleteMember: onDeleteMemberHandler,
    onInviteMember: onInviteMemberHandler,
  }),
);

export default enhance(Members);
